export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1A_V1_SIGN_UP_SIGN_IN",
        editProfile: "B2C_1A_V1_PROFILE_EDIT"
    },
    authorities: {
        signUpSignIn: {
            authority: "https://logindev.maitland.nsw.gov.au/9ca74413-1ad5-4da6-935d-69b956fb5b6a/B2C_1A_V1_SIGN_UP_SIGN_IN",
        },
        editProfile: {
            authority: "https://logindev.maitland.nsw.gov.au/9ca74413-1ad5-4da6-935d-69b956fb5b6a/B2C_1A_V1_PROFILE_EDIT",
        },
    },
    authorityDomain: "logindev.maitland.nsw.gov.au"
};

export const msalConfig = {
    auth: {
        clientId: "2817ad57-13f6-4d98-bcd2-deca04c8950a",
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: "http://localhost:3000/"
    }, cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true
    }
};
/*
export const protectedResources = {
    apiList: {
        endpoint: "http://localhost:3000/apiList",
        scopes: { 
            read: ["https://maitlandcitycouncilnpb2c.onmicrosoft.com/users-api/users.read"],
            write: ["https://maitlandcitycouncilnpb2c.onmicrosoft.com/users-api/users.write"]
        },
    },
}

export const loginRequest = {
    scopes: [...protectedResources.apiList.scopes.read, ...protectedResources.apiList.scopes.write]
};*/